import React from 'react'
import { rankWith, scopeEndsWith } from '@jsonforms/core'

import ElementWrapper from 'designer/component/display/layout/control/ElementWrapper'
import DragElementWrapper from 'designer/component/system/layout/control/DragElementWrapper'

import PageControl from 'designer/component/control/page/NumberControl'
import FavoriteControl from 'designer/component/control/favorite/NumberControl'

export const PageNumberSystem = (props) => (
  <DragElementWrapper {...props}>
    <PageControl {...props} />
  </DragElementWrapper>
)

export const PageNumberDisplay = (props) => (
  <ElementWrapper {...props}>
    <PageControl {...props} />
  </ElementWrapper>
)

export const FavoriteNumber = (props) => (
  <ElementWrapper {...props}>
    <FavoriteControl {...props} />
  </ElementWrapper>
)

export const numberTester = rankWith(1000, scopeEndsWith('number'))
